export type AnalyticsEventName =
  | "screen_view"
  | "onboarding_step_view"
  | "onboarding_step_complete"
  | "onboarding_skip"
  | "daily_route_view"
  | "daily_route_complete"
  | "daily_route_claim"
  | "achievement_ready"
  | "achievement_view"
  | "achievement_claim"
  | "premium_offer_view"
  | "premium_invoice_open"
  | "premium_paid"
  | "premium_cancelled"
  | "arena_queue_start"
  | "arena_queue_cancel"
  | "arena_guardian_match"
  | "arena_pvp_match"
  | "request_complete"
  | "client_error"
  | "market_wallet"
  | "tap_delivery";

export type AnalyticsValue = string | number | boolean | null;
export type AnalyticsProperties = Readonly<Record<string, AnalyticsValue>>;

export type AnalyticsContext = {
  readonly clientVersion: string;
  readonly platform: "ios" | "android" | "desktop" | "unknown";
  readonly locale: "ru" | "en" | "unknown";
};

export type GameAnalyticsEvent = {
  readonly eventId: string;
  readonly name: AnalyticsEventName;
  readonly occurredAt: string;
  readonly context: AnalyticsContext;
  readonly properties: AnalyticsProperties;
};

export type GameAnalyticsPort = {
  bindUser?(userId: string): void;
  track(name: AnalyticsEventName, properties?: AnalyticsProperties): void;
  flush(): Promise<void>;
  snapshot(): readonly GameAnalyticsEvent[];
  destroy(): void;
};

export class NullGameAnalytics implements GameAnalyticsPort {
  track(_name: AnalyticsEventName, _properties: AnalyticsProperties = {}): void {
    void _name;
    void _properties;
  }
  flush(): Promise<void> { return Promise.resolve(); }
  snapshot(): readonly GameAnalyticsEvent[] { return []; }
  destroy(): void { return undefined; }
}
